import React , { useRef , useState , useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import logodark from '../../assets/real_images/logo/logo-blackfont1.png'
import logodark2x from '../../assets/real_images/logo/logo-blackfont1.png'
import logoWhiteFont from '../../assets/real_images/logo/logo-whitefont1.png'
import enUS from '../../data/en-US'
import { useLanguageContext } from "../../context/languageContext";
import Button from '../buttons/Button';
import Cookies from 'js-cookie';
import ClickAwayListener from 'components/layouts/ClickAwayListener';
import { contributorLogout } from 'actions/contributor/contributorAuthActions';
import { getUserById } from 'actions/contributor/homeActions';
import { BiLogOut } from 'react-icons/bi';
import { FaUserEdit } from 'react-icons/fa';
import { AiFillCaretDown, AiFillCaretUp } from 'react-icons/ai';

const Header = ({active}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { language } = useLanguageContext()
    
    const [ menus, setMenus ] = useState([]) 
    
    const [ isUserMenuOpen, setIsUserMenuOpen ] = useState(false);
    const [ user, setUser ] = useState();

    const signedinUser = useSelector(state => state.signedinUser.userInfo)

    useEffect(() => {
        setUser(signedinUser)
    }, [signedinUser])

    const handleAvatarClick = () => {
        setIsUserMenuOpen(true);
    };

    const handleLogout = () => {
        dispatch(contributorLogout())
        navigate('/')
    }
    
    const info = {
        'en-US': enUS
    }
    
    useEffect(() => {
        setMenus(info[language].homepage.header_menu.header_menu_1)
    }, [])
    
    const headerRef = useRef (null)
    useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });
    useEffect(() => {
        const userCookie = Cookies.get('userInfo');
        if (userCookie) {
            dispatch(getUserById(JSON.parse(userCookie).id))
        }
    }, []);
       
    const isSticky = (e) => {
        const header = document.querySelector('.js-header');
        const scrollTop = window.scrollY;
        if (header && scrollTop) {
            scrollTop >= 160 ? header.classList.add('is-fixed') : header.classList.remove('is-fixed');
            scrollTop >= 160 ? header.classList.add('is-small') : header.classList.remove('is-small');
        }
    };

    const menuLeft = useRef(null)
    const btnToggle = useRef(null)

    const menuToggle = () => {
        menuLeft.current.classList.toggle('active');
        btnToggle.current.classList.toggle('active');
    }

    const [activeIndex, setActiveIndex] = useState(null);
    const handleOnClick = index => {
        setActiveIndex(index); 
    };

    return (
        <header id="header_main" className="header_1 js-header" ref={headerRef}>
            <div className="themesflat-container">
                <div className="row">
                    <div className="col-md-12">                              
                        <div id="site-header-inner"> 
                            <div className="wrap-box flex">
                                <div id="site-logo" className="clearfix">
                                    <div id="site-logo-inner">
                                        <Link to="/" rel="home" className="main-logo d-flex">
                                                <img className='logo-white w-100 h-100 mr-3'  id="logo_header" src={logodark} srcSet={`${logodark2x}`} alt="luncsphere" />
                                                <img className='logo-white h-100 mt-2'  id="logo_header" src={logoWhiteFont} srcSet={`${logoWhiteFont}`} alt="luncsphere" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="mobile-button" ref={btnToggle} onClick={menuToggle}><span></span></div>
                                <nav id="main-nav" className="main-nav" ref={menuLeft} >
                                    <ul id="menu-primary-menu" className="menu">
                                        {
                                            menus && menus.map((data,index) => (
                                                <li key={index} onClick={()=> handleOnClick(index)} className={`menu-item ${data.namesub ? 'menu-item-has-children' : '' }` }   >
                                                    <Link to={data.links} className={`font-face-pop ${active === data.name ? 'header-menu-active' : ''}`}>{data.name}</Link>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </nav>
                                <div className="flat-search-btn flex optional-login">
                                    {
                                        user ? (
                                            <div className='header-loggedin-wrapper'>
                                                <span className='header-loggedin-user-welcome'>Hi! {user.alias}</span>
                                                <div className='header-loggedin-user-avatar flex cursor-pointer' onClick={handleAvatarClick} >
                                                    <img src={user.avatar} alt="User avatar" />
                                                    {
                                                        isUserMenuOpen ? 
                                                        <AiFillCaretUp className='my-auto ml-3 text-white' />
                                                        : 
                                                        <AiFillCaretDown className='my-auto ml-3 text-white'/>
                                                    }
                                                </div>
                                                {
                                                    isUserMenuOpen && (
                                                        <ClickAwayListener handleClickAway={() => setIsUserMenuOpen(!isUserMenuOpen)}>
                                                            <div className="absolute z-10 right-0 w-60 bg-white rounded-md shadow-md avatar-dropdown-menu">
                                                                <Link to={'contributor/create-profile'}>
                                                                    <div className='pb-3 pt-3 text-center flex profile-button-wrapper font-medium cursor-pointer hover:bg-gray-200 transition-all duration-300'>
                                                                        <FaUserEdit className='my-auto mx-3'/>
                                                                        My Profile                                                                    
                                                                    </div>
                                                                </Link>
                                                                <div onClick={handleLogout} className='text-center pb-3 pt-3 flex logout-button-wrapper font-medium cursor-pointer hover:bg-gray-200 transition-all duration-300'>
                                                                    <BiLogOut className='my-auto mx-3'/>
                                                                    Logout
                                                                </div>
                                                            </div>
                                                        </ ClickAwayListener>
                                                    ) 
                                                }
                                            </div>
                                        ) : (
                                            <>
                                                <nav>
                                                    <ul id="menu-primary-menu">
                                                        <li>
                                                            <Link to="/contributor-login" className={`header-contributors font-face-pop ${active === 'Contributors' && 'header-menu-active'}`}>Contributors</Link>
                                                        </li>
                                                    </ul>
                                                </nav>
                                                <div className="sc-btn-top" id="site-header">
                                                    <Link to="/" className='font-face-pop'>
                                                        <Button 
                                                            width={150} 
                                                            height={50} 
                                                            text={'Premium Users'} 
                                                            borderRadius={5} 
                                                            theme='gradient'
                                                        />
                                                    </Link>
                                                </div>
                                            </>
                                        )
                                    }
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
